module.exports = __webpack_public_path__ + "img/19+.2c011950.png";